import { createSlice, current } from '@reduxjs/toolkit'

const addNoteSlice = createSlice({
  name: 'notes',
  initialState: {
    data: [],
  },
  reducers: {
    // getNotes: (state, action) => {
    //   state.data = { ...action.payload }
    // },
    addNotes: (state, action) => {
      state.data = [...state.data, action.payload]
    },
    updateNote: (state, action) => {
      const id = action.payload.id
      const notes = current(state.data)

      let copyNote = [...notes]
      let fileteredNoteIndex = notes.findIndex(note => note.id == id);
  
      copyNote[fileteredNoteIndex] =  action.payload
      state.data =[...copyNote]
    }, 
    deleteNotes: (state, action) => {
      const id = action.payload.id
      const notes = current(state.data)

      
      let fileteredNote = notes.filter(note => note.id !== id);
  
      
      state.data =[...fileteredNote]

    }
  },
})

// action creators
export const {
  // getNotes,
  addNotes,
  updateNote,
  deleteNotes,
} = addNoteSlice.actions

export const fetchCurrentOverViewNotes = (state) => state.notes.data.filter(note => note.type === 1)
export const fetchCurrentStaysNotes = (state) => state.notes.data.filter(note => note.type === 2)
export const fetchCurrentStopNotes = (state) => state.notes.data.filter(note => note.type === 3)

export default addNoteSlice.reducer
